import { ButtonKVBase, DefaultModal, InputKVBase } from '@/presentation/components';
import { mapToCardinal } from '@/presentation/functions/cardinal';
import useCustomToast from '@/presentation/hooks/use-custom-toast';
import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useRecoilState, useResetRecoilState } from 'recoil';
import { manageStudentsAtom } from '../atoms';
import { addStudentsManuallyAtom, addStudentFormAtom } from './atoms';
import Styles from './modal-add-students-styles.scss';
import Select from '../select/select';
import useUserSesssion from '@/presentation/hooks/use-user-session';
import { PLANS } from '@/presentation/constants/plans';
import { ALL_GRADES } from '@/presentation/constants/class-grades';
import InfoText from '@/presentation/components/info-text/info-text';
const ModalAddStudent = ({ validation }) => {
    var _a, _b, _c, _d, _e;
    const [addStudentsManuallyState, setAddStudentsManuallyState] = useRecoilState(addStudentsManuallyAtom);
    const [manageStudentsState, setManageStudentsState] = useRecoilState(manageStudentsAtom);
    const [state, setState] = useRecoilState(addStudentFormAtom);
    const resetState = useResetRecoilState(addStudentFormAtom);
    const resetStateStudent = useResetRecoilState(addStudentsManuallyAtom);
    const { showCustomError } = useCustomToast({
        containerId: 'main-dashboard-container'
    });
    useEffect(() => {
        resetState();
        resetStateStudent();
    }, []);
    const closeModalAddStudent = () => setAddStudentsManuallyState(prev => (Object.assign(Object.assign({}, prev), { modalAddStudent: false, studentForEdit: null, studentForRemove: null })));
    const validate = (field) => {
        setState(prev => {
            const formData = Object.assign({}, prev);
            const error = validation.validate(field, formData);
            formData[`${field}Error`] = error;
            formData.isFormInvalid =
                !!formData.firstNameError || !!formData.lastNameError || !!formData.emailError || !!formData.idClassSelectedError;
            return Object.assign({}, formData);
        });
    };
    useEffect(() => {
        if (state.firstName)
            validate('firstName');
    }, [state.firstName]);
    useEffect(() => {
        if (state.lastName)
            validate('lastName');
    }, [state.lastName]);
    useEffect(() => {
        if (state.email)
            validate('email');
    }, [state.email]);
    useEffect(() => {
        validate('idClassSelected');
    }, [state.idClassSelected]);
    const isFormEmpty = () => {
        return state.firstName === '' || state.lastName === '' || state.email === '' || !state.idClassSelected;
    };
    const saveStudent = () => {
        var _a;
        const cloneArray = [...addStudentsManuallyState.studentsForSave];
        if ((_a = addStudentsManuallyState.studentForEdit) === null || _a === void 0 ? void 0 : _a.email) {
            const filtered = cloneArray.filter(i => {
                return i.email !== addStudentsManuallyState.studentForEdit.email;
            });
            filtered.push({
                firstName: state.firstName,
                lastName: state.lastName,
                email: state.email,
                idClassSelected: state.idClassSelected
            });
            setAddStudentsManuallyState(prev => (Object.assign(Object.assign({}, prev), { modalAddStudent: false, mainModal: true, studentsForSave: filtered, studentForEdit: null, studentForRemove: null })));
            resetState();
        }
        else {
            const existsItem = cloneArray.find(i => i.email === state.email);
            if (existsItem) {
                showCustomError('Error', 'Already exists this email');
            }
            else {
                cloneArray.push({
                    firstName: state.firstName,
                    lastName: state.lastName,
                    email: state.email,
                    idClassSelected: state.idClassSelected
                });
                const classData = manageStudentsState.classList.find(item => item.id === parseInt(state.idClassSelected.value));
                setAddStudentsManuallyState(prev => (Object.assign(Object.assign({}, prev), { modalAddStudent: false, mainModal: true, studentsForSave: cloneArray, classData })));
                resetState();
            }
        }
    };
    useEffect(() => {
        var _a, _b, _c;
        if ((_b = (_a = addStudentsManuallyState.studentForEdit) === null || _a === void 0 ? void 0 : _a.idClassSelected) === null || _b === void 0 ? void 0 : _b.value) {
            setState(prev => {
                var _a, _b;
                return (Object.assign(Object.assign({}, prev), { idClassSelected: {
                        value: (_a = addStudentsManuallyState.studentForEdit) === null || _a === void 0 ? void 0 : _a.idClassSelected,
                        label: (_b = addStudentsManuallyState.studentForEdit) === null || _b === void 0 ? void 0 : _b.idClassSelected
                    }, idClassSelectedError: null }));
            });
        }
        if ((_c = addStudentsManuallyState.studentForEdit) === null || _c === void 0 ? void 0 : _c.email) {
            setState(prev => {
                var _a, _b, _c;
                return (Object.assign(Object.assign({}, prev), { email: (_a = addStudentsManuallyState.studentForEdit) === null || _a === void 0 ? void 0 : _a.email, firstName: (_b = addStudentsManuallyState.studentForEdit) === null || _b === void 0 ? void 0 : _b.firstName, lastName: (_c = addStudentsManuallyState.studentForEdit) === null || _c === void 0 ? void 0 : _c.lastName }));
            });
        }
    }, [addStudentsManuallyState.modalAddStudent, addStudentsManuallyState.classData]);
    const { getClient } = useUserSesssion();
    const client = getClient();
    let optionsClass = manageStudentsState.classList.map(item => {
        var _a;
        return ({
            value: `${item.id}`,
            label: `${(_a = mapToCardinal(item === null || item === void 0 ? void 0 : item.grades)) === null || _a === void 0 ? void 0 : _a.join(',')} Grade, ${item === null || item === void 0 ? void 0 : item.name}`
        });
    });
    const isIndividualPlan = (client === null || client === void 0 ? void 0 : client.plan) === PLANS.ANNUAL_INDIVIDUAL || (client === null || client === void 0 ? void 0 : client.plan) === PLANS.SEMI_ANNUAL_INDIVIDUAL;
    if (isIndividualPlan) {
        optionsClass = ALL_GRADES.map(item => ({
            value: `${item}`,
            label: `${item}`
        }));
    }
    useEffect(() => {
        var _a;
        if ((_a = addStudentsManuallyState.classData) === null || _a === void 0 ? void 0 : _a.id) {
            setState(prev => (Object.assign(Object.assign({}, prev), { idClassSelected: optionsClass.find(item => { var _a, _b; return item.value === ((_b = (_a = addStudentsManuallyState.classData) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.toString()); }), idClassSelectedError: null })));
        }
    }, [(_a = addStudentsManuallyState.classData) === null || _a === void 0 ? void 0 : _a.id, addStudentsManuallyState.modalAddStudent]);
    return (React.createElement(React.Fragment, null,
        React.createElement(DefaultModal, { height: "432", hUnit: "px", width: "776", wUnit: "px", open: addStudentsManuallyState.modalAddStudent, onClose: closeModalAddStudent, showClose: true, overlayCustomStyles: { zIndex: 9999 } },
            React.createElement(Container, { className: Styles.addStudent },
                React.createElement("div", { className: Styles.title }, "Add a Student"),
                React.createElement("div", { style: {
                        fontWeight: 500,
                        fontSize: '0.9rem',
                        lineHeight: '1.25rem',
                        color: '#FFA800'
                    } },
                    React.createElement(InfoText, null,
                        React.createElement("div", { style: {
                                width: '100%'
                            } }, "Students need a different email than the one used by the registrant. If you're signing up as a student, just go back and choose 'Register Myself As A Student'."))),
                React.createElement("div", { className: Styles.subtitle }, "Student Information"),
                React.createElement(Row, { className: "py-2" },
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(InputKVBase, { type: "text", name: "firstName", placeholder: "ie. Oliver", label: "FIRST NAME", state: state, setState: setState, required: true, defaultValue: (_b = addStudentsManuallyState.studentForEdit) === null || _b === void 0 ? void 0 : _b.firstName })),
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(InputKVBase, { type: "text", name: "lastName", placeholder: "ie. Green", label: "LAST NAME", state: state, setState: setState, required: true, defaultValue: (_c = addStudentsManuallyState.studentForEdit) === null || _c === void 0 ? void 0 : _c.lastName }))),
                React.createElement(Row, { className: "py-2" },
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(InputKVBase, { type: "email", name: "email", placeholder: "ie. oliver.green@mail.com", label: "EMAIL", state: state, setState: setState, required: true, defaultValue: (_d = addStudentsManuallyState.studentForEdit) === null || _d === void 0 ? void 0 : _d.email })),
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(Select, { name: "idClassSelected", label: "GRADE AND CLASS NAME", required: true, state: state, setState: setState, placeholder: 'ie. 5th Grade, 5-B', options: optionsClass, isDisabled: ((_e = addStudentsManuallyState.classData) === null || _e === void 0 ? void 0 : _e.id) !== undefined, showError: true }))),
                React.createElement(Row, { className: "py-4" },
                    React.createElement(Col, null,
                        React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", onClick: saveStudent, disabled: state.isFormInvalid || isFormEmpty() }, "Confirm")))))));
};
export default ModalAddStudent;
